import React from 'react';
import { AppButton, Box, Heading } from '@common-fe/common-fe';

import ROUTES from '@/common/routes';
import HeaderLink from '@/components/elements/HeaderLink';

interface ServicesHeaderProps {
  isPageMode?: boolean;
  isCreateAccessible: boolean;
  onCreateService: () => void;
}

const ServicesHeader: React.FC<ServicesHeaderProps> = ({
  isPageMode,
  isCreateAccessible,
  onCreateService,
}) => {
  return (
    <Box data-testid="services-header_wrapper" direction="row" align="center" justify="between">
      {isPageMode ? (
        <Box pad={{ vertical: 'spacing24' }}>
          <Heading level={4} size="large" color="textTitle">
            Services
          </Heading>
        </Box>
      ) : (
        <Box margin={{ top: 'spacing24', bottom: 'spacing16' }}>
          <HeaderLink path={ROUTES.SERVICES} title="Services" />
        </Box>
      )}
      {isCreateAccessible && (
        <AppButton testId="services-header_create-button" onClick={onCreateService} width="200px">
          Create New Service
        </AppButton>
      )}
    </Box>
  );
};

export default ServicesHeader;
